<!-- 组件详情 -->
<template>
    <div class="container">
        <div class="title">商品信息</div>
        <div class="card">
            <img
                v-if="info_data.icon"
                :src="info_data.show_icon"
                class="card-icon"
            />
            <div class="card-right">
                <div class="card-title">{{ info_data.name }}</div>
                <div v-if="info_data.desc">
                    {{ info_data.desc }}
                </div>
            </div>
            <template v-if="info_data.name">
                <Button
                    v-if="!info_data.is_permission"
                    class="theme-bc theme-default-color buy-btn"
                    @click="goBuy"
                    >去购买</Button
                >
            </template>
        </div>
        <div v-if="info_data.details">
            <div class="title mt24">使用说明</div>
            <div class="content">
                <div v-html="info_data.details"></div>
            </div>
        </div>

        <!-- 购买插件 -->
        <Modal
            v-model="money_modal"
            title="购买插件"
            width="700"
            @on-cancel="cancelMoneyModal"
        >
            <div class="money-container">
                <div class="title">商品信息</div>
                <div class="card">
                    <img
                        v-if="info_data.icon"
                        :src="info_data.show_icon"
                        class="card-icon"
                    />
                    <div class="card-right">
                        <div class="card-title">{{ info_data.name }}</div>
                        <div v-if="info_data.desc">
                            {{ info_data.desc }}
                        </div>
                    </div>
                </div>
                <div class="title mt24">应支付金额</div>
                <div class="dis-flex-container">
                    <div class="mr36">
                        <div class="money-title">￥{{ info_data.price }}</div>
                        <div v-if="info_data.original_price">
                            原价￥{{ info_data.original_price }}
                        </div>
                    </div>
                    <div class="money-img-container">
                        <img
                            v-if="loading"
                            src="@/assets/loading.gif"
                            alt="加载中"
                            class="loading-img-container"
                        />
                        <VueQr
                            v-else-if="qrcode_data"
                            id="vueQr"
                            :text="qrcode_data"
                        ></VueQr>
                    </div>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template> 

<script>
import { apps_info, apps_buy, version_query } from "@/api/index";
import VueQr from "vue-qr";
export default {
    components: { VueQr },
    data() {
        return {
            id: "",
            info_data: {},
            money_modal: false,
            qrcode_data: "",
            order_id: "",
            timer: null, // 存储定时器ID
            loading: false,
            apps_id: "",
        };
    },
    mounted() {
        if (this.$route.query.title) {
            this.$route.meta.title = this.$route.query.title;
        }
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getInfo();
        }
        if (this.$route.query.apps_id) {
            this.apps_id = this.$route.query.apps_id;
        }
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        this.clearInterval();
    },
    methods: {
        getInfo() {
            apps_info({ id: this.id }).then((res) => {
                this.info_data = res.data;
            });
        },
        goBuy() {
            this.loading = true;
            this.getAppsBuy();
        },
        getAppsBuy() {
            var data = {
                version_id: this.info_data.id,
                pay_type: 1,
            };
            apps_buy(data)
                .then((res) => {
                    // 0元购
                    if(res.data && res.data.code && res.data.code == 200){
                        this.$Message.success(res.data.msg);
                        setTimeout(() => {
                            this.getInfo();
                        }, 1000);
                        return
                    }
                    this.qrcode_data = res.data.data;
                    this.order_id = res.data.order_id;
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                    this.startInterval();
                    this.money_modal = true;
                })
                .catch((err) => {
                    this.qrcode_data = "";
                    this.$Message.error(err.msg);
                });
        },
        goVersionQuery() {
            version_query({ order_id: this.order_id }).then((res) => {
                // 0 未付款 1 付款成功
                if (res.data == 1) {
                    this.$Message.success("支付成功");
                    this.money_modal = false;
                    this.clearInterval();
                    setTimeout(() => {
                        this.getInfo();
                    }, 1000);
                }
            });
        },
        // 启动定时器
        startInterval() {
            this.timer = setInterval(() => {
                this.goVersionQuery();
            }, 5000);
        },
        // 清除定时器
        clearInterval() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        cancelMoneyModal() {
            this.clearInterval();
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px 36px;
    min-height: 400px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    margin-bottom: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
}
.card {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.card-icon {
    margin-right: 12px;
    width: 58px;
    height: 58px;
}
.card-right {
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
}
.card-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #010101;
}
.content {
    margin-left: 24px;
}
.buy-btn {
    margin-left: 36px;
    border-radius: 10px;
}
.money-container {
    margin: 24px 36px;
}
.dis-flex-container {
    margin-left: 24px;
    display: flex;
}
.money-title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #de0000;
}
.money-txt {
    margin-left: 6px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    font-size: 14px;
    color: #999999;
    text-decoration-line: line-through;
}
.mr36 {
    margin-right: 36px;
}
.money-img-container {
    margin-top: -36px;
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
}
.loading-img-container {
    width: 50px;
    height: 50px;
}
</style>